import * as fcl from "@onflow/fcl"
import { Button } from "react-bootstrap";
import ReactGA from "react-ga4";

export function AuthCluster({ user }) {

  if (user.loggedIn) {

    return (
      <div>
        <Button style={{width: "200px"}} variant="find-outline-dark" onClick={fcl.unauthenticate}>Log Out</Button>
      </div>
    )
  } else {
    return (
      <div>
        <Button variant="find" onClick={() => {
          fcl.logIn();
          ReactGA.event("login", {
            method: "wallet"
          });
          }
        } style={{ width: "220px" }}>Connect Wallet</Button>
      </div>
    )
  }
}